import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { getOrgInfo, getOrgsForDoc, getOrgsForStage } from '../../../dict/ORGS'
import { Li } from '.'
import RootStoreContext from '../../../storage/RootStore'

/// functions
/// types
/// components

interface OrganizationsProps {
    forStage?: string,
    forDoc?: string
}

export const Organizations: React.FC<OrganizationsProps> = observer(({
    forStage: stageID,
    forDoc: docID
}) => {

    const { selection } = useContext(RootStoreContext)


    if (stageID && !selection.doc){
        return (
            <>
                <p><b>Організації пов'язані з етапом</b></p>
                <ul>
                    {getOrgsForStage(stageID).map(orgID => {
                        let { orgFullname } = getOrgInfo(orgID)
    
                        const id = `org-${orgID}-connected`
    
                        const onClick = () => {
                            selection.setView('structure'); 
                            selection.setOrg(orgID)
                        }
    
                        return (
                            <Li key={id} id={id} onClick={onClick}>
                                {orgFullname}
                            </Li>
                        )
                    })}
                </ul>
            </>
        )
    }




    if (docID){
        return (
            <>
                <p>
                    <b>Організації, які підписують документ</b>
                </p>
                <ul>
                {getOrgsForDoc(docID).map(orgID => {

                    const onClick = () => {
                        selection.setView('structure'); 
                        selection.setOrg(orgID)
                    }

                    return (
                        <Li key={orgID}
                            id={orgID}
                            onClick={onClick}
                            children={getOrgInfo(orgID).orgFullname}
                        />
                    )
                })}
                </ul>
            </>
        )

    }

    return null
})
